export default __webpack_public_path__ + "static/media/Snd_02.0db78a34.mp3";